
import { Component, Vue, Watch } from "vue-property-decorator";
import Scan from "@/components/Scan.vue";
import TagList from "@/components/shared/TagList.vue";
import BatchRefInput from "@/components/BatchRefInput.vue";
import BatchQuantityInput from "@/components/BatchQuantityInput.vue";
import NotesInput from "@/components/NotesInput.vue";
import TotalTagsScanned from "@/components/TotalTagsScanned.vue";
import { withdrawalDaysFromToday } from "@/helpers/withdrawal";
import * as Models from "@gigalot/data-models";
import lodash from "lodash";

@Component({
  components: {
    Scan,
    TagList,
    BatchRefInput,
    BatchQuantityInput,
    NotesInput,
    TotalTagsScanned,
  },
})
export default class Count extends Vue {
  batchNumber: string = "";
  batchQuantity: string = "";
  notes: string = "";
  isUiLocked: boolean = false;

  created() {
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => {
        this.$router.go(-1);
      },
    });
  }

  onClearWhenSaved() {
    this.batchNumber = "";
    this.batchQuantity = "";
    this.notes = "";
    this.$store.commit("headCount/batchQuantity", "");
    this.$store.commit("headCount/batchNumber", "");
    this.$store.commit("headCount/notes", "");
  }

  sgtins: string[] = [];
  animals: (Models.Animal & { withdrawalDays?: number })[] = [];

  get tags() {
    const tags: Models.Tag[] = this.$store.state.scan.tags;
    this.sgtins = tags.map((t) => t.sgtin);
    return this.$store.state.scan.tags;
  }

  animalQueue: { sgtin: string }[] = [];
  isProcessingQueue: boolean = false;

  async processQueue() {
    let item;
    this.isProcessingQueue = true;
    while ((item = this.animalQueue.shift())) {
      const animal = await this.$store.dispatch("data/getAnimal", item.sgtin);
      if (animal) {
        animal.withdrawalDays = withdrawalDaysFromToday(animal);
        this.animals.push(animal);
      }
      //clear list if tags cleared while busy
      if (this.sgtins.length === 0) {
        this.animalQueue = [];
        this.animals = [];
        break;
      }
      //await new Promise((resolve, _) => setTimeout(resolve, 50));
    }
    this.isProcessingQueue = false;
  }

  @Watch("sgtins")
  onSgtinsChanged(val: string[], oldVal: string[]) {
    const newSgtins = lodash.difference(val, oldVal); //only lookup new sgtins, otherwise it seems that the system looks up too many of the same animals
    const addAnimal = async (sgtin: string) => {
      this.animalQueue.push({ sgtin });
      if (!this.isProcessingQueue) {
        this.processQueue();
      }
    };
    for (const sgtin of newSgtins) addAnimal(sgtin);

    //Clear animals if tags are cleared
    if (val.length === 0) {
      this.animals = [];
    }
  }

  //Gets called when a valid kraal is selected, not when user is typing (that's searchInput)
  // @Watch("kraalId")
  // async onKraalIdChanged(val: any, oldVal: any) {
  //   this.$store.commit("headCount/kraalId", val);
  // }

  @Watch("batchNumber")
  async onBatchNumberChanged(val: any, oldVal: any) {
    this.$store.commit("headCount/batchNumber", val);
  }

  @Watch("batchQuantity")
  async onBatchQuantityChanged(val: any, oldVal: any) {
    this.$store.commit("headCount/batchQuantity", parseInt(val));
  }

  @Watch("notes")
  async onNotesChanged(val: any, oldVal: any) {
    this.$store.commit("headCount/notes", val);
  }

  async mounted() {
    this.$store.commit("scan/setAppMode", "head-count");

    //If we mount and appState was saving then flag error since saving wasn't finished.
    if (this.$store.state.scan.appState === "saving") {
      this.$store.commit("scan/flagError");
    }

    //get kraalIds for autocomplete
    //this.kraalIds = await this.$store.dispatch("data/getKraalIds");
    //await this.$store.dispatch("data/linkSgtinsToAnimalsFromDb", this.tags);

    if (this.tags.length > 0) {
      this.batchQuantity = this.$store.state.headCount.batchQuantity ?? "";
      this.batchNumber = this.$store.state.headCount.batchNumber || "";
      this.notes = this.$store.state.headCount.notes || "";
      //Keep kraal id if there are still tags
      //this.kraalId = this.$store.state.count.kraalId;
    } else {
      this.$store.commit("headCount/batchQuantity", "");
      this.$store.commit("headCount/batchNumber", "");
      //If no tags then clear kraal id
      //this.$store.commit("headCount/kraalId", "");
      this.$store.commit("headCount/notes", "");
    }
    this.$store.dispatch("power/setPowerMode", "high");
  }

  async onSave() {
    await this.$store.dispatch("headCount/save");
    this.isUiLocked = true;
  }
}
